import { BookingInquiryFields, BookingInquiryRoutePlan } from '@models/next/BookingInquiry';
import { z } from 'zod';

export const BookingInquiryLogField = z.enum([
  'shipper',
  'receiver',
  'consignee',
  'has_pickups',
  'cargos',
  'trade_condition',
  'customer_no',
  'special_note',
  'use_trading_agency',
  'trading_agency_payer',
  'use_rcep',
  'preferred_arrival_date',
  'pickup_date',
  'move_in_date',
  'route_plan',
]);

export type BookingInquiryLogField = z.infer<typeof BookingInquiryLogField>;

export const BookingInquiryLogValue = z
  .object({
    shipper: BookingInquiryFields.shape.shipper,
    receiver: BookingInquiryFields.shape.receiver,
    consignee: BookingInquiryFields.shape.consignee,
    has_pickups: BookingInquiryFields.shape.has_pickups,
    cargos: BookingInquiryFields.shape.cargos,
    trade_condition: BookingInquiryFields.shape.trade_condition,
    customer_no: BookingInquiryFields.shape.customer_no,
    special_note: BookingInquiryFields.shape.special_note,
    use_trading_agency: BookingInquiryFields.shape.use_trading_agency,
    trading_agency_payer: BookingInquiryFields.shape.trading_agency_payer,
    use_rcep: BookingInquiryFields.shape.use_rcep,
    preferred_arrival_date: BookingInquiryFields.shape.preferred_arrival_date,
    pickup_date: BookingInquiryFields.shape.pickup_date,
    move_in_date: BookingInquiryFields.shape.move_in_date,
    route_plan: BookingInquiryRoutePlan,
  })
  .partial();

export type BookingInquiryLogValue = z.infer<typeof BookingInquiryLogValue>;

export const BookingInquiryLog = z.object({
  id: z.number(),
  group_id: z.string(),
  has_read: z.boolean(),
  edited_field: BookingInquiryLogField,
  before_value: BookingInquiryLogValue,
  after_value: BookingInquiryLogValue,
  created_at: z.string(),
  updated_at: z.string(),
});

export type BookingInquiryLog = z.infer<typeof BookingInquiryLog>;
